<template>
  <div class="tb-form-group" v-on:keyup.stop="">
    <template v-if="!editable">
      <div>
        {{ mappingLabel }}
      </div>
    </template>

    <template v-else>
      <quill-editor
        v-model="element.text"
        ref="editor"
        :content="element.text"
        :options="editorOptions"
        data-entity="producer-editor-text"
        @change="editorChange"
      />

      <p
        v-if="element.limitCharacters"
        class="text-right"
      >
        {{ characterCount }} / {{ element.maxCharacterLength }}
      </p>

      <emoji-picker
        :search="search"
        @emoji="append"
      >
        <div
          class="emoji-invoker"
          slot="emoji-invoker"
          slot-scope="{ events: { click: clickEvent } }"
          @click.stop="clickEvent"
        >
          <span class="icon icon-happy" />
        </div>

        <div slot="emoji-picker" slot-scope="{ emojis, insert, display }">
          <div
            class="emoji-picker"
            :style="{
              bottom: `calc(${display.height - display.y}px - 0.5rem)`,
              right: `calc(100vw - ${display.x}px + 3rem)`,
            }"
          >
            <div class="emoji-picker__search">
              <input class="tb-input" type="text" v-model="search">
            </div>
            <div>
              <div v-for="(emojiGroup, category) in emojis" :key="category">
                <h5>{{ category }}</h5>
                <div class="emojis">
                  <span
                    v-for="(emoji, emojiName) in emojiGroup"
                    :key="emojiName"
                    @click="insert(emoji)"
                    :title="emojiName"
                  >{{ emoji }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </emoji-picker>
    </template>
  </div>
</template>

<script lang="js">
import { get } from 'lodash-es';

import EmojiPicker from '../../../emoji-picker/EmojiPicker.vue';

export default {
  props: ['element', 'graphic_fields'],

  components: {
    'emoji-picker': EmojiPicker,
  },

  data() {
    return {
      search: '',
      editorOptions: {
        modules: {
          toolbar: [
            [
              { align: '' },
              { align: 'center' },
              { align: 'right' },
              { align: 'justify' },
              'bold',
              'italic',
              'underline',
              'strike',
              { list: 'ordered' },
              { list: 'bullet' },
            ],
          ],
        },
        clipboard: {
          matchVisual: false,
        },
      },
    };
  },

  computed: {
    editable() {
      // sheets, only a single property can be mapped (which is text)
      if (this.element.data?.columnIdx || this.element.data?.columnIdx === 0) {
        return !get(this.element, 'data.provider');
      }

      // only disable if text property is mapped
      return !get(this.element, 'data.dataKeyMap.text');
    },

    mappingLabel() {
      if (this.editable) {
        return '';
      }

      if (this.element.data?.columnIdx || this.element.data?.columnIdx === 0) {
        return `Field mapped to column ${this.element.data.columnIdx + 1} of sheet data`;
      }

      if (this.element.data?.dataKeyMap?.text) {
        return `Field mapped to ${this.element.data.dataKeyMap.text}`;
      }

      return 'Field mapped to data';
    },

    characterCount() {
      const div = document.createElement('div');
      div.innerHTML = this.element.text;
      const contentLength = div.textContent.length;

      // counting the children makes line breaks count as characters
      return contentLength > 0 ? contentLength + (div.children.length - 1) : 0;
    },
  },
  methods: {
    append(emoji) {
      this.$refs.editor.quill.focus();
      let caretPosition = this.$refs.editor.quill.getSelection(true);
      if (!caretPosition.index && !caretPosition.length) {
        caretPosition = this.$refs.editor.quill.getLength() - 1;
      }

      this.$refs.editor.quill.insertText(caretPosition, emoji);
    },

    handlelimitCharacters() {
      const limit = this.element.maxCharacterLength;
      const textLength = this.$refs.editor.quill.getLength();

      if (textLength - 1 > limit) {
        this.$refs.editor.quill.deleteText(limit, textLength);
      }

      return this.$refs.editor.quill.root.innerHTML;
    },

    editorChange(e) {
      let newText = e.html;
      if (this.element.limitCharacters) {
        newText = this.handlelimitCharacters();
      }

      this.$emit('value', { value: newText, field: 'text' });
    },
  },

  mounted() {
    if (this.$refs.editor) {
      this.$refs.editor.quill.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) => {
        const ops = [];
        delta.ops.forEach((op) => {
          if (op.insert && typeof op.insert === 'string') {
            ops.push({
              insert: op.insert,
            });
          }
        });

        delta.ops = ops; // eslint-disable-line no-param-reassign
        return delta;
      });
    }
  },
};
</script>
